import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PRIORITY_LABELS, TicketService } from '../../_services/ticket.service';
import { formatDateBR } from '../../_helpers/dateUtil';

@Component({
  selector: 'app-confirmation-overlay',
  templateUrl: './confirmation-overlay.component.html',
  styleUrls: ['./confirmation-overlay.component.css']
})
export class ConfirmationOverlayComponent implements OnInit, OnDestroy {
  isVisible = false;
  ticketData: any = null;
  summaryItems: { label: string; value: string }[] = [];
  formName: string = '';
  attachmentCount: number = 0;
  private subscription: Subscription;

  constructor(private ticketService: TicketService) {}

  ngOnInit(): void {
    this.subscription = this.ticketService.getConfirmationRequest().subscribe((data) => {
      this.show(data);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  show(data: any): void {
    this.ticketData = data;
    this.formName = data.ticket?.form?.name || 'Ticket';
    this.attachmentCount = data.anexoTickets?.length || 0;
    this.summaryItems = this.buildSummary(data);
    this.isVisible = true;
    document.body.style.overflow = 'hidden';
  }

  hide(): void {
    this.isVisible = false;
    document.body.style.overflow = '';
  }

  onCancel(): void {
    this.hide();
    this.ticketService.sendConfirmationResponse(false);
  }

  onConfirm(): void {
    this.hide();
    this.ticketService.sendConfirmationResponse(true);
  }

  private buildSummary(data: any): { label: string; value: string }[] {
    const items: { label: string; value: string }[] = [];
    const ticketItems = data.ticket?.ticketItems || [];

    const groupedItems: { [key: string]: string[] } = {};

    for (const item of ticketItems) {
      const label = item.field?.description || 'Campo';
      const raw = item.value;
      const value = raw instanceof Date ? formatDateBR(raw) : (raw || '');
      if (!groupedItems[label]) {
        groupedItems[label] = [];
      }
      groupedItems[label].push(value);
    }

    for (const label of Object.keys(groupedItems)) {
      items.push({ label, value: groupedItems[label].join(', ') });
    }

    if (data.ticket?.priority) {
      items.push({ label: 'Prioridade', value: PRIORITY_LABELS[data.ticket.priority] || data.ticket.priority });
      if (data.ticket.priorityJustification) {
        items.push({ label: 'Justificativa', value: data.ticket.priorityJustification });
      }
    }

    return items;
  }
}
